import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {HeaderComponent} from './header.component';
import {CustomMaterialModule} from '@app/core/material.module';
import {RouterModule} from '@angular/router';
import {FormsModule} from '@angular/forms';
import {FlexLayoutModule} from '@angular/flex-layout';
import {MatBadgeModule} from '@angular/material/badge';
import {DynamicFieldsModule} from '@app/modules/dynamic-fields/dynamic-fields.module';
import {ButtonModule} from '@components/button/modules/button.module';
import {ShowTooltipModule} from '@directives/show-tooltip/show-tooltip.module';
import {FormFilterSavedSearchesService} from '@app/modules/table/services/form-filter-saved-searches.service';

@NgModule({
    declarations: [HeaderComponent],
    imports: [
        MatBadgeModule,
        CommonModule,
        CustomMaterialModule,
        RouterModule,
        FormsModule,
        FlexLayoutModule,
        DynamicFieldsModule,
        ButtonModule,
        ShowTooltipModule
    ],
    exports: [HeaderComponent]
})
export class HeaderModule {
}
